"use strict";

define('app/document/diff/document.diff.controller',['require','exports','module','underscore','rs/abstract.content.controller','app/document/diff/document.diff.calculator','app/document/diff/document.diff.view','rs/form/factory','rs/models/document','e3-modal','datakit/util/url','jquery'],function (require, exports, module) {
  'use strict';

  var _ = require('underscore');
  var AbstractContentController = require('rs/abstract.content.controller');
  var DiffCalculator = require('app/document/diff/document.diff.calculator');
  var DocumentDiffView = require('app/document/diff/document.diff.view');
  var FormFactory = require('rs/form/factory');
  var Document = require('rs/models/document');
  var E3Modal = require('e3-modal');
  var url = require('datakit/util/url');
  var $ = require('jquery');
  var FRAGMENT_CLASS = 'form-object-diff-fragment';
  var DocumentDiffController = AbstractContentController.extend({
    contentName: 'document-diff-content abstract-content',
    properties: ['initialSectionIndex', 'previousFormController', 'currentFormController', 'documentModel', 'sections', 'activeSection', 'viewingPreviousDocument'],
    events: {
      'view:ready': 'render'
    },
    footer: false,
    viewingPreviousDocument: false,
    initialize: function initialize() {
      this._super.apply(this, arguments);
      this.sync('sections');
      this.sync('documentModel');
      this.sync('viewingPreviousDocument');
    },
    setupView: function setupView() {
      this.setView(new DocumentDiffView());
    },
    getUserId: function getUserId() {
      var user = this.getAppController().getUser().getUsername();
      return user;
    },
    start: function start(id, section) {
      var that = this;
      section = section || 0;
      return FormFactory.createFormDiffPair(id, this.getUserId()).spread(function (current, previous) {
        that.formsDidLoad(current, previous);
        current.on('change:activeSection', that.initializeDiffFormDOM.bind(that));
        previous.on('change:activeSection', that.initializeDiffFormDOM.bind(that));
        return Promise.join(that.getDocumentModel().requestAnswerData().then(function (ans) {
          return Promise.resolve(ans);
        }), that.getPreviousAnswers().then(function (ans) {
          return Promise.resolve(ans);
        }));
      }).spread(function (currentAnswers, previousAnswers) {
        if (!previousAnswers.length && that.getDocumentModel().getTemplateType() == "Modification") {
          that.setViewingPreviousDocument(true);
          return Promise.join(currentAnswers, that.getPreviousDocumentAnswers());
        } else {
          return Promise.join(currentAnswers, previousAnswers);
        }
      }).spread(function (currentAnswers, previousAnswers) {
        that.loadAnswersIntoForm(that.getPreviousFormController(), previousAnswers);
        that.loadAnswersIntoForm(that.getCurrentFormController(), currentAnswers);
        that.activateForms();
        that.loadSections();
        return that.activateSection(that.getFormSectionByIndex(section));
      }).bind(this).fail(this.formDidFail);
    },
    initializeDiffFormDOM: function initializeDiffFormDOM(controller, sectionViewDelegate) {
      var that = this;
      var setUpDOM = function setUpDOM(sectionView, sectionDiffs) {
        var changedSectionDiffs = sectionDiffs.changed;
        that.resetExistingTabIndices(sectionView);
        if (changedSectionDiffs && changedSectionDiffs.length) {
          changedSectionDiffs.forEach(function (diffItem) {
            var diffFormObjectView = diffItem.getView();
            that.setTabIndexOnDiffedFormObjects(diffFormObjectView, sectionDiffs);
          });
        }
      };
      if (!sectionViewDelegate) {
        var previousDelegate = this.getActiveSection().left;
        var currentDelegate = this.getActiveSection().right;
        this.initializeDiffFormDOM(this.previousFormController, previousDelegate);
        this.initializeDiffFormDOM(this.currentFormController, currentDelegate);
        return;
      }
      this.listenTo(sectionViewDelegate.getView(), 'change:available', function (sectionView, isRendered) {
        var sectionDiffs = this.getDiffData(sectionViewDelegate);
        _.defer(setUpDOM, sectionView, sectionDiffs);
      });
    },
    resetExistingTabIndices: function resetExistingTabIndices(sectionView) {
      var $tabIndexedElements = sectionView.$el.find('[tabindex]').not('.compare-button');
      var $tabbableElements = sectionView.$el.find('input', 'a');
      var hasBeenProcessed = false;
      $tabIndexedElements.each(function () {
        var tabIndex = this.getAttribute('tabindex');
        hasBeenProcessed = $(this).hasClass(FRAGMENT_CLASS);
        if (!hasBeenProcessed && parseInt(tabIndex) > -1) {
          this.removeAttribute('tabindex');
        }
      });
      $tabbableElements.each(function () {
        hasBeenProcessed = $(this).hasClass(FRAGMENT_CLASS);
        if (!hasBeenProcessed) {
          this.setAttribute('tabindex', '-1');
        }
        ;
      });
    },
    getFormObjectDiffPairs: function getFormObjectDiffPairs(formObjectView) {
      var isPreviousFormObjectView = formObjectView.$el.attr('id').indexOf('prev-') !== -1;
      var formObjectPairsArray = [];
      var twinFormObjectView, twinFormObjectId;
      twinFormObjectId = isPreviousFormObjectView ? formObjectView.$el.attr('id').substr(5) : 'prev-' + formObjectView.$el.attr('id');
      twinFormObjectView = $('#' + twinFormObjectId);
      formObjectPairsArray.push(formObjectView.$el, twinFormObjectView);
      return formObjectPairsArray;
    },
    setTabIndexOnDiffedFormObjects: function setTabIndexOnDiffedFormObjects(formObjectView, sectionDiffs) {
      var hasBeenSet = formObjectView.$el.hasClass(FRAGMENT_CLASS);
      var formObjectDiffPairs = this.getFormObjectDiffPairs(formObjectView);
      var that = this;
      if (hasBeenSet) {
        return;
      }
      formObjectDiffPairs.forEach(function (diffView, index, formObjectView) {
        var previousOrCurrent = diffView.attr('id').indexOf('prev-') !== -1 ? 'previous ' : 'current ';
        var accessibleTextHTML = '<div class="accessibility-text">changed content, selected item is ' + previousOrCurrent + ':</span>';
        diffView.attr({
          tabindex: 0
        }).addClass(FRAGMENT_CLASS).prepend(accessibleTextHTML);
      });
    },
    getFormSectionByIndex: function getFormSectionByIndex(index) {
      var rSection = this.getCurrentFormController().getSections(),
        section = null;
      section = _.findWhere(this.getSections(), {
        right: rSection[index]
      });
      return section || this.getSections()[0];
    },
    getIndexOfFormSection: function getIndexOfFormSection(section) {
      var sections = this.getCurrentFormController().getSections();
      return sections.indexOf(section.right);
    },
    getPreviousAnswers: function getPreviousAnswers() {
      if (this._previousAnswerData) {
        return Promise.resolve(this._previousAnswerData);
      }
      return this.getDocumentModel().requestPreviousAnswerData().bind(this).then(function (answers) {
        return this._previousAnswerData = answers;
      });
    },
    getPreviousDocumentAnswers: function getPreviousDocumentAnswers() {
      if (this._previousDocumentAnswerData) {
        return Promise.resolve(this._previousDocumentAnswerData);
      }
      var that = this,
        initialDoc = this.getDocumentModel();
      return Document.requestApprovedDocuments(initialDoc.studyId).then(function (docs) {
        docs = _.chain(docs).filter(function (doc) {
          var templateType = doc.templateType;
          return doc.activityDate < initialDoc.activityDate && (templateType === 'Initial' || templateType === 'Modification' || templateType === 'Legacy');
        }).sortBy(function (doc) {
          return doc.activityDate;
        }).value();
        if (docs.length) {
          return docs[docs.length - 1].requestAnswerData().then(function (answers) {
            return that._previousDocumentAnswerData = answers;
          });
        } else {
          return Promise.resolve([]);
        }
      });
    },
    formsDidLoad: function formsDidLoad(current, previous) {
      var view = this.getView();
      this.setCurrentFormController(current);
      this.setPreviousFormController(previous);
      var doc = current.getDocumentModel();
      this.setDocumentModel(doc);
      current.setAppController(this.getAppController());
      current.setDiffController(this);
      previous.setAppController(this.getAppController());
      previous.setDiffController(this);
      if (doc.getTemplateType() == "Modification") {
        this.getView().enableDocumentSelector();
      }
    },
    loadAnswersIntoForm: function loadAnswersIntoForm(formController, answers) {
      formController.clearDiffCache();
      formController.setEmptyAnswers(!answers.length);
      formController.loadNewAnswerSet(answers);
    },
    getFormObjectsWithDifferingHeight: function getFormObjectsWithDifferingHeight() {
      var section = this.getActiveSection(),
        right = section.right._diffData.changed,
        left = section.left._diffData.changed;
      return {
        right: right,
        left: left
      };
    },
    loadSections: function loadSections() {
      var rSections = this.getCurrentFormController().getSections(),
        lSections = this.getPreviousFormController().getSections(),
        sections = [],
        section = null;
      for (var i = 0, len = rSections.length; i < len; i++) {
        var rSectionVisible = rSections[i].isVisible(),
          lSectionVisible = lSections[i].isVisible();
        if (rSectionVisible || lSectionVisible) {
          section = rSections[i];
          sections.push({
            title: (section.getLabel() ? section.getLabel() + ' ' : '') + section.getText(),
            left: lSections[i],
            right: rSections[i],
            changed: !(lSectionVisible && rSectionVisible)
          });
        }
      }
      this.setSections(sections);
      this.getView().renderSections();
    },
    activateSectionByDirection: function activateSectionByDirection(d) {
      var active = this.getActiveSection(),
        sections = this.getSections(),
        activeIndex = sections.indexOf(active),
        sectionIndex = activeIndex;
      if (d == 'previous') {
        --sectionIndex;
      } else {
        ++sectionIndex;
      }
      this.activateSection(sections[sectionIndex]);
    },
    activateSection: function activateSection(section) {
      var current = this.getCurrentFormController(),
        prev = this.getPreviousFormController();
      this.updateRoute(section);
      this.getView().removeAllHightlights();
      this.getView().resetScroll();
      Promise.all([current.activateSection(section.right), prev.activateSection(section.left)]).bind(this).delay(100).tap(function () {
        if (prev.getEmptyAnswers()) {
          this.getView().showEmptyPreviousFormMessage();
        } else {
          this.getView().hideEmptyPreviousFormMessage();
        }
        this.setActiveSection(section);
        this.getView()._activeDiff = null;
        this.getView().refresh();
      });
    },
    activateForms: function activateForms() {
      this.getCurrentFormController().setup(this.getView().getFormRightContainerElement());
      this.getPreviousFormController().setup(this.getView().getFormLeftContainerElement());
      this.getView().showForms();
    },
    sectionsDidChange: function sectionsDidChange(initialSection) {},
    requestNavigatePrevious: function requestNavigatePrevious() {
      var activeSection = this.getActiveSection().right;
      if (!activeSection || !activeSection.isVisible()) {
        activeSection = null;
      } else {
        activeSection = _.indexOf(this.getCurrentFormController().getSections(), activeSection);
      }
      this.getAppController().navigateDocument(this.getDocumentModel(), {
        trigger: true
      }, activeSection);
    },
    getDiffDataCount: function getDiffDataCount(section) {
      var count = 0;
      if (section.right) {
        count += this.getChangedFormObjects(section.right).length;
        count += this.getHiddenFormObjects(section.right).length;
      }
      if (section.left) {
        count += this.getHiddenFormObjects(section.left).length;
      }
      return count;
    },
    getDiffData: function getDiffData(section) {
      if (!section._diffData) {
        var otherSection = this.getMirroredFormObject(section);
        DiffCalculator.calculateDiff.call(this, section, otherSection);
      }
      return section._diffData;
    },
    compareAttachments: function compareAttachments(leftDocStoreId, rightDocStoreId) {
      var view = this.getView();
      Document.requestDiffView(leftDocStoreId, rightDocStoreId).then(function (resp) {
        view.showDocumentDiffViewer(resp);
      }).caught(function (error) {
        view.hideDocumentDiffViewer();
        throw error;
      }).lastly(this.showLoading());
    },
    refreshDocumentModelPropertyOnView: function refreshDocumentModelPropertyOnView() {
      var dm = this.getDocumentModel();
      if (dm) {
        this.getView().setTitle(dm.getStudyLabel() + " (" + dm.getTemplateType() + ")");
      }
    },
    changePreviousAnswers: function changePreviousAnswers(answers) {
      var that = this;
      var id = this.getDocumentModel().id;
      var currentSection = this.getActiveSection();
      var sectionIndex = currentSection ? this.getIndexOfFormSection(currentSection) : 0;
      return FormFactory.createFormDiffPair(id, this.getUserId()).spread(function (current, previous) {
        that.formsDidLoad(current, previous);
        current.on('change:activeSection', that.initializeDiffFormDOM.bind(that));
        previous.on('change:activeSection', that.initializeDiffFormDOM.bind(that));
        return that.getDocumentModel().requestAnswerData();
      }).then(function (currentAnswers) {
        that.loadAnswersIntoForm(that.getPreviousFormController(), answers);
        that.loadAnswersIntoForm(that.getCurrentFormController(), currentAnswers);
        that.activateForms();
        that.loadSections();
        return that.activateSection(that.getFormSectionByIndex(sectionIndex));
      }).bind(this).fail(this.formDidFail);
    },
    requestChangePreviousAnswers: function requestChangePreviousAnswers(doc) {
      var getAnswers = doc == 'prev-doc' ? this.getPreviousDocumentAnswers : this.getPreviousAnswers;
      getAnswers.apply(this).bind(this).tap(this.changePreviousAnswers)["finally"](this.showLoading());
    },
    refreshViewingPreviousDocumentPropertyOnView: function refreshViewingPreviousDocumentPropertyOnView() {
      var isPrevDoc = this.getViewingPreviousDocument();
      this.getView().setDocumentSelector(isPrevDoc ? 'prev-doc' : 'same-doc');
    },
    getHiddenFormObjects: function getHiddenFormObjects(section) {
      return this.getDiffData(section).hidden;
    },
    getChangedFormObjects: function getChangedFormObjects(section) {
      return this.getDiffData(section).changed;
    },
    getMirroredFormObject: function getMirroredFormObject(formObject) {
      var myFc = formObject.getFormController();
      if (myFc == this.getCurrentFormController()) {
        return this.getPreviousFormController().getFormObjectByID(formObject.getId());
      } else {
        return this.getCurrentFormController().getFormObjectByID(formObject.getId());
      }
    },
    formDidFail: function formDidFail(err) {
      E3Modal.BtnMsgModal.show({
        title: 'Error',
        message: err,
        buttons: 'Ok'
      });
    },
    unload: function unload() {
      this._super();
      var current = this.getCurrentFormController(),
        previous = this.getPreviousFormController();
      if (current) {
        current.unload();
      }
      if (previous) {
        previous.unload();
      }
    },
    destroy: function destroy() {
      this._super();
      if (this.formController) {
        return this.formController.destroy();
      }
    },
    updateRoute: function updateRoute(section) {
      var index = _.indexOf(this.getCurrentFormController().getSections(), section.right);
      this.getAppController().navigateDiff(this.getDocumentModel(), {
        trigger: false
      }, index);
    }
  });
  module.exports = DocumentDiffController;
});

